import { render, staticRenderFns } from "./Pesan.vue?vue&type=template&id=03569fb2&scoped=true"
import script from "./Pesan.vue?vue&type=script&lang=js"
export * from "./Pesan.vue?vue&type=script&lang=js"
import style0 from "./Pesan.vue?vue&type=style&index=0&id=03569fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03569fb2",
  null
  
)

export default component.exports